import { HOOK_GRID2D_CELL__size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__size';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { GRID2D_CELL__loading_grid2d } from '../../grid2d_cell/views/GRID2D_CELL__loading_grid2d';

interface PROPS {
  entity: DTO__entity_with_grid2d;
}

export function GRID2D__loading({ entity }: PROPS) {
  const { cell_width, cell_height } = HOOK_GRID2D_CELL__size(entity);

  return (
    <div className="size-full overflow-auto relative bg-component flex items-start justify-start">
      <GRID2D_CELL__loading_grid2d {...{ cell_width, cell_height }} />
    </div>
  );
}
